export const RECIPIENT_SECTION_ROUTES = {
    RECIPIENT: "recipient",
    ADD: "add",
    EDIT: "edit",
    RECIPIENT_ADDED: "recipientadded",
    MOVE_RECIPIENTS: "move"
}

export const RECIPIENT_SECTION_LOADING_STATES = {
    FETCHING_PAYERS_LIST_LOADING: "FETCHING_PAYERS_LIST_LOADING",
    FETCHING_PAYERS_LIST_READY: "FETCHING_PAYERS_LIST_READY",
}

export const RECIPIENT_SECTION_MESSAGE_MAP = {
    [RECIPIENT_SECTION_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]: "Loading"
}
